/*

Added by Wholesale Helper - Armin

*/

if (window.is_wcp_wholesale_customer == true) {  
  let wpdPriceElements = document.querySelectorAll("[data-wpd-id]:not(.wpd-processed-units)");
  if (wpdPriceElements.length != 0) {
    updateWPDPrice(wpdPriceElements);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      wpdPriceElements = document.querySelectorAll("[data-wpd-id]:not(.wpd-processed-units)");
      if (wpdPriceElements.length != 0) {
        updateWPDPrice(wpdPriceElements);
      }
    });
  }
  
  const observerSearch = new MutationObserver((mutations) => {
    wpdPriceElements = document.querySelectorAll("[data-wpd-id]:not(.wpd-processed-units)");
    if (wpdPriceElements.length > 0) {
      updateWPDPrice(wpdPriceElements);
    }
  });

  let wpdBodyInterval = setInterval(function () {
    if (document.querySelector("body") != null) {
      clearInterval(wpdBodyInterval);
      observerSearch.observe(document.querySelector("body"), {
        subtree: true,
        childList: true,
      });
    }
  }, 250);

  function updateWPDPrice(elements) {
    // Retrieves WPDs discounts from metafields
    elements.forEach((el) => {
      const productId = el.dataset.wpdId;
      const wpdJsonEl = document.querySelector(`#wcp_json_${productId}`);
      if (!wpdJsonEl) return; // exit early if JSON data is missing
      const wpdData = JSON.parse(wpdJsonEl.textContent);
      let units = parseInt(el.dataset.wpdUnits) || (wpdData.tags.includes('12') ? 12 : wpdData.tags.includes('18') ? 18 : 1);
      const unitPrice = parseInt(el.dataset.wpdUnitPrice) / units;
      const discountPrice = wpdData.price;
      const discountUnitPrice = discountPrice / units;
      if (isNaN(unitPrice) || isNaN(discountUnitPrice)) return;
      if (unitPrice == discountUnitPrice) return
      wpdFormatUnitPrice(el, unitPrice, discountUnitPrice);
    });

    // Retrieves fresh discounts directly from server
    let handles = Array.from(elements).map((el) => el = el.dataset.wpdHandle);
    console.log('handles: ', handles);
    let fetchData = {
      method: "POST",
      async: true,
      cache: "no-cache",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        "admin_domain": window.Shopify.shop,
        "customer_tags": window.wcp_customer.tags,
        "buyers_country": window.Shopify.country,
        "market_country": window.Shopify.country,
        "third_party_caller": true,
        "specific_product_handle_query": true,
        "handles": handles.join(',')
      }),
    };
    
    fetch(`https://bdr.wholesalehelper.io/cost-tree/shopify-products-prices-retrieval/`, fetchData)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        elements.forEach((el) => {
          const productId = el.dataset.wpdId;
          let productDiscount = data.prices_data.products.find((product) => product.id == productId);
          if (productDiscount) {
            let units = parseInt(el.dataset.wpdUnits) || (wpdData.tags.includes('12') ? 12 : wpdData.tags.includes('18') ? 18 : 1);
            const unitPrice = parseInt(productDiscount.compare_at_price) * 100 / units;
            const discountPrice = productDiscount._wpd_price;
            const discountUnitPrice = discountPrice / units;
            if (isNaN(unitPrice) || isNaN(discountUnitPrice)) return;
            if (unitPrice == discountUnitPrice) return
            wpdFormatUnitPrice(el, unitPrice, discountUnitPrice);
          }
        })
      })
      .catch(error => console.error(error));
  }
}

function wpdFormatPrice(price) {
  return window.WPDMoneyFormat.replace(/({{\s*amount\s*}})/g, (price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    .replace(/({{\s*amount_no_decimals\s*}})/g, Math.ceil(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
    .replace(/({{\s*amount_with_comma_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
    .replace(/({{\s*amount_no_decimals_with_comma_separator\s*}})/g, Math.ceil(price / 100).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, "."))
    .replace(/({{\s*amount_with_apostrophe_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
    .replace(/({{\s*amount_no_decimals_with_space_separator\s*}})/g, Math.ceil(price / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
    .replace(/({{\s*amount_with_space_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ",").replace(/\B(?=(\d{3})+(?!\d))/g, " "))
    .replace(/({{\s*amount_with_period_and_space_separator\s*}})/g, (price / 100).toFixed(2).toString().replace(/(\.)/g, ".").replace(/\B(?=(\d{3})+(?!\d))/g, " "));
}

function wpdFormatUnitPrice(element, unitPrice, discountUnitPrice) {
  const formattedUnitPrice = wpdFormatPrice(unitPrice);
  const formattedDiscountUnitPrice = wpdFormatPrice(discountUnitPrice);
  element.innerHTML = window.showCrossOutPrice
    ? `<span class="wpd-ext-compare-at-price" style="text-decoration: line-through;">${formattedUnitPrice}</span><span>${formattedDiscountUnitPrice}</span>`
    : `<span>${formattedDiscountUnitPrice}</span>`;
  element.classList.add('wpd-processed-units');
}